import { useEffect, useState } from 'react';
import { ExtendedProductDetailProduct } from 'shared/types/product/Product';
import { ExtendedVariant } from 'shared/types/product/Variant';
import { getTrafficSource } from 'helpers/trafficSource';

interface UseProductTrackingProps {
  product: ExtendedProductDetailProduct;
  onProductView: (
    trackingProduct: ExtendedProductDetailProduct & {
      trafficSource: string;
      activeVariant: ExtendedVariant;
    },
  ) => void;
}

export const useProductTracking = ({ product, onProductView }: UseProductTrackingProps) => {
  const [trackedProductId, setTrackedProductId] = useState<string | null>(null);

  useEffect(() => {
    if (!product.productId) {
      return;
    }

    // Only track if we haven't tracked this specific product
    if (trackedProductId === product.productId) {
      return;
    }

    const activeVariant = product.variants[0];

    const trackingProduct = {
      ...product,
      trafficSource: getTrafficSource(),
      activeVariant: activeVariant,
    };

    onProductView(trackingProduct);
    setTrackedProductId(product.productId);
  }, [product.productId, onProductView, trackedProductId]);

  return {
    hasTracked: trackedProductId === product.productId,
  };
};
